<span>{{ displayedText }}</span>
